<template>
<span>
  <b-tooltip
    label="Share Institutional Report Link"
    position="is-bottom"
    v-show="!running"
  >
    <a
      href="#_"
      label=""
      @click="generateHtmlReport"
    >
      <b-icon
        pack="fas"
        icon="share-alt-square"
      />
    </a>
  </b-tooltip>
  <b-icon
    pack="fas"
    icon="circle-notch"
    class="fa-spin is-primary"
    v-show="running"
  />
</span>
</template>

<script>
  import InstitutionalReportLinkForm from '@frontend/dash3/js/components/report-links/institutional/InstitutionalReportLinkForm.vue';
  import { apiFetch } from '../../../../../api/api';

  export default {
    data() {
      return {
          running: false,
          action: 'generate_html',
          checkInterval: null,
          runId: null,
      }
    },
    props: {
      reportUrl: String,
      portfolio: Object,
    },
    methods: {
      generateHtmlReport() {
      if (this.running) {
        return
      }
      if (this.checkInterval) {
        window.clearInterval(this.checkInterval);
      }
      this.running = true;
      let [reportPath, reportSearch] = this.reportUrl.split('?');
      let qsArgs = new URLSearchParams(reportSearch);
      qsArgs.set('printing', 1);
      apiFetch(
          `/api/v1/process/report/${this.action}/`,
          {
            method: 'POST',
            headers: {
              'X-CSRFToken': this.$root.$data.csrfToken,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              report_url: `${reportPath}?${qsArgs}`,
              portfolio_id: this.portfolio.external_id || this.portfolio.id,
            })
          },
        )
        .then((data) => {
          return data.json();
        })
        .then((data) => {
          this.runId = data.task.id;
          this.checkInterval = window.setInterval(() => {
            apiFetch(`/report-status/${this.runId}/`)
              .then((data) => {
                return data.json();
              })
              .then((data) => {
                if (data.status) {
                  if (data.status === 'new') {
                    return
                  }

                  window.clearInterval(this.checkInterval);
                  this.checkInterval = null;
                  this.running = false;

                  if (data.status === 'complete') {
                      
                    this.cardReportLink(data.id);
                  }
                  if (data.status === 'error') {
                    alert("There was an error generating your share link, please try again.");
                  }
                }
              });
          }, 2000);
        });
    },
      cardReportLink(renderedReportId) {
        this.$buefy.modal.open({
          parent: this,
          component: InstitutionalReportLinkForm,
          hasModalCard: true,
          customClass: 'custom-class custom-class-2',
          trapFocus: true,
          props: {'reportUrl': this.reportUrl, 'portfolio': this.portfolio, 'renderedReportId': renderedReportId}
        });
      }
    }
  }
</script>